import { render, staticRenderFns } from "./PeriodItem.vue?vue&type=template&id=244e5b42&scoped=true&"
import script from "./PeriodItem.vue?vue&type=script&lang=js&"
export * from "./PeriodItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e5b42",
  null
  
)

export default component.exports